import CollectionSection from '../../../components/organisms/collectionSection';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const PromoCollectionsTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return <CollectionSection {...data} />;
};

export default tastify({ translate: true, connect: { context: true } })(PromoCollectionsTastic);
